module.exports = __webpack_public_path__ + "img/circle_drop.6b0eae62.png";